import { useEffect } from "react";
import { useTheme } from "./ThemeProvider";

export const ThemeStyleBridge = () => {
  const { tokens } = useTheme();

  useEffect(() => {
    const root = document.documentElement;

    root.style.setProperty("--background", tokens.background);
    root.style.setProperty("--surface", tokens.surface);
    root.style.setProperty("--surface-alt", tokens.surfaceAlt);
    root.style.setProperty("--border", tokens.border);
    root.style.setProperty("--text-primary", tokens.textPrimary);
    root.style.setProperty("--text-secondary", tokens.textSecondary);
    root.style.setProperty("--primary", tokens.primary);
    root.style.setProperty("--primary-soft", tokens.primarySoft);
    root.style.setProperty("--success", tokens.success);
    root.style.setProperty("--warning", tokens.warning);
    root.style.setProperty("--danger", tokens.danger);
    root.style.setProperty("--shadow", tokens.shadow);
    root.style.setProperty("--glass", tokens.glass);
  }, [tokens]);

  return null;
};